import Quickview from './components/quickview';
import Integrations from './integrations/integrations';
// Fire up the quickview!
new Quickview();
// Then also run any integrations.
new Integrations();
